import { render, staticRenderFns } from "./decoration.vue?vue&type=template&id=1e0ab0c1&"
import script from "./decoration.vue?vue&type=script&lang=js&"
export * from "./decoration.vue?vue&type=script&lang=js&"
import style0 from "./decoration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports